import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './root/App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

/**
 * Service worker — condition d'installation sur Android.
 *
 * Chrome n'émet `beforeinstallprompt`, et ne propose donc « Ajouter à l'écran
 * d'accueil », que si le site enregistre un service worker répondant aux
 * navigations. En développement il n'est pas enregistré : un worker actif
 * masquerait le rechargement à chaud.
 */
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      // Un enregistrement raté ne doit rien casser : le site fonctionne sans,
      // seule l'invitation à installer disparaît.
      console.warn("Service worker non enregistré :", error);
    });
  });
}
